import { DidomiContext } from 'app/app';
import { getDocCMS } from 'app/modules/cms/service/cmsService';
import { getDocument, isReady } from 'app/modules/cms/service/store/selectors';
import { getActiveSubscriptionByClient } from 'app/modules/contract/service';
import { RulesKeys } from 'app/modules/rules/domain/rules.keys';
import { RulesContext } from 'app/modules/rules/domain/RulesContext';
import { getAppDataConf } from 'app/modules/rules/service/rulesService';
import { getRulesDataByKey } from 'app/modules/rules/service/store/selectors';
import { Login } from 'app/pages/mobile/login/login';
import PrivateRoute from 'app/shared/auth/private-route';
import PublicRoute from 'app/shared/auth/public-route';
import Header from 'app/shared/components/mobile/header/header';
import { IRootState } from 'app/shared/reducers';
import { componentImportName } from 'app/shared/util/methode-util';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Switch, useHistory, useLocation } from 'react-router-dom';
import { ContractDocumentsPage } from '../common/contract-documents/contract-documents';
import './app.mobile.style.scss';

const MobileRoutes = props => {

  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [query, setQuery] = useState(new URLSearchParams(location.search));

  const didomi = useContext(DidomiContext);
  const isAuthenticated: any = useSelector<IRootState>(state => state.authentication.isAuthenticated);

  const configuration: any = useSelector<IRootState>(state => state.global.configuration);

  const rulesDataResponse = useSelector(getRulesDataByKey(RulesKeys.GET_CONF));
  const sideNavData: any = useSelector<IRootState>(getDocument('generic_side_nav_mobile_v2'));

  const cmsIsReady: any = useSelector<IRootState>(isReady);
  const ruleRootMap = (Object.entries(rulesDataResponse?.routerConfig)) as [];

  const rulesContext: RulesContext = {
    key: RulesKeys.GET_CONF,
    entryDataRules: {},
  };

  useEffect(() => {
    if (isAuthenticated && rulesDataResponse?.dataRecoveryService?.find(service => service === 'GetActiveSubscriptionList')) {
      dispatch(getActiveSubscriptionByClient());
    }
  }, []);

  useEffect(() => {

    dispatch(getAppDataConf(rulesContext));
    dispatch(getDocCMS('desktop_contract_and_claim_status_v2'));

    if (rulesDataResponse?.dataRecoveryService?.find(service => service === 'GETGENEREICSIDENAVMOBILE')) {
      dispatch(getDocCMS('generic_side_nav_mobile_v2'));
      dispatch(getDocCMS('avatar_information'));
    }
    if (query.get('claimNumber') && query.get('action') === 'upload') {
      history.push(`/claims/${query.get('claimNumber')}`, { claimNumber: query.get('claimNumber'), action: 'upload' });
    } else if (query.get('claimNumber') && query.get('action') === 'follow') {
      history.push(`/claims/${query.get('claimNumber')}`, { claimNumber: query.get('claimNumber'), action: 'follow' });
    } else if (query.get('claimNumber')) {
      history.push(`/claims`, { claimNumber: query.get('claimNumber'), action: 0 });
    } else if (query.get('documentName')) {

      history.push({
        pathname: '/document',
        state: { documentName: query.get('documentName'), default: query.get('default') },
      });
    }

  }, [rulesDataResponse]);

  const componentName = componentImportName;

  return (
    <div className="mobile-view">
      <Header
        didomi={didomi}
        productCode={configuration}
        ListData={rulesDataResponse?.composeApp}
        sideNavCmsData={sideNavData?.data}
      />
      <div className="mobile-page-routes">
        {cmsIsReady && (
          <Switch>
            {configuration?.specificRedirectUrl === "" && <PublicRoute path={"/signin"} component={Login} />}
            <PrivateRoute redirectionUrl={configuration?.specificRedirectUrl} path={"/document"} component={ContractDocumentsPage} />
            {ruleRootMap.map((value, index) => (
              <PrivateRoute redirectionUrl={configuration?.specificRedirectUrl} key={index} path={value[0]} exact component={componentName[value[1]]} />
            ))}
            <Redirect to="/contracts" />
          </Switch>
        )}
      </div>
    </div>
  );
};

export default MobileRoutes;
